"use client";

import { ONEVIEW_SOURCE, type OneViewSource, type OneViewSourceKey } from "@/lib/oneview/provenance";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function OneViewMark({
  source,
  compact = false,
}: {
  source: OneViewSource | OneViewSourceKey;
  compact?: boolean;
}) {
  const info = typeof source === "string" ? ONEVIEW_SOURCE[source] : source;
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            tabIndex={0}
            className={cn(
              "inline-flex shrink-0 cursor-help items-center rounded-full border border-[#dc2626] bg-[#fee2e2] px-1.5 font-semibold text-[#991b1b]",
              compact ? "text-[9.5px] leading-4" : "text-[10.5px] leading-[18px]",
            )}
            aria-label={`OneView API: ${info.operation}. ${info.fields}`}
          />
        }
      >
        OneView
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[280px] text-left">
        <div className="font-semibold">{info.operation}</div>
        <div className="mt-0.5 opacity-90">{info.path}</div>
        <div className="mt-1 opacity-90">{info.fields}</div>
      </TooltipContent>
    </Tooltip>
  );
}

export function OneViewLegend() {
  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-[#dc2626] bg-[#fee2e2]/70 px-3 py-2 text-[12px] text-[#991b1b]">
      <OneViewMark source="search" />
      <p>
        <strong className="font-semibold">Highlighted fields</strong> can be filled from existing OneView REST APIs
        (MAUI). Hover a OneView mark for the operation and path. Unmarked regions stay on Helix, CPNI session, MCP
        prediction, or later-phase services.
      </p>
    </div>
  );
}
